import { RootState } from "redux/rootReducer";

export const selectIsLoadingMiniStress = (state: RootState) =>
  state.miniStressCheckTypeInfo.loading;
export const selectMiniStressErrorMessage = (state: RootState) =>
  state.miniStressCheckTypeInfo.error;
export const miniStressCheckTypeInfoDataResponse = (state: RootState) =>
  state.miniStressCheckTypeInfo.miniStressCheckTypeInfoResponse;
